import React from 'react'
import Label from "components/general/Label";
import { ColumnName, ColumnNoc, ColumnExpander } from "components/common/TableColumns"
import SportCode from "components/common/SportCode"

function ColumnRank(){
    return (
        {
            Header: <Label data="HeaderRank" />,
            className: 'text-end',
            headerClassName: 'text-end',
            disableSortBy: true,
            id: 'Rank',
            Cell: (props) => {
                const row = props.cell.row.original
                const rankEqual = row?.resultRankEqual === 'Y' ? 'T' : ''
                const rank = (row?.resultType === 'IRM')
                    ? <SportCode discipline="GLF" code={row?.resultIrm} entity="@IRM" abbr={true}/>
                    : row?.resultRank 
                        ? rankEqual+row?.resultRank 
                        : ''
                return rank
            }
        }
    )
}

function ColumnHolePar(){
    return (
        {
            Header: <><div><Label data={"HeaderHole"} /></div><div><Label data={"HeaderPar"} /></div></>,
            className: 'text-start',
            headerClassName: 'text-start',
            disableSortBy: true,
            id: 'HolePar',
            Cell: (props) => {
                return ''    
            }
        }
    )  
}

function ColumnHole(data, ei){
    const pos = ei.ei_pos
    const hole = ei.ei_value
    const par = data?.config?.extendedConfig.find(c => c.code === 'HOLE' && c.pos === hole)?.value
    return (
        {
            Header: <><div>{hole}</div><div>{par}</div></>,
            className: 'text-end',
            headerClassName: 'text-end',
            disableSortBy: true,
            id: 'Hole'+pos,
            Cell: (props) => {
                const row = props.cell.row.original
                const value = row?.extendedResults?.find(er => er.er_code === 'HOLE' && er.er_pos === pos)?.er_value
                return value
            }
        }
    )    
}

export function TableColumns(data) {
    let cols = [
        ColumnRank(),
        ColumnNoc({disableSort: true}),
        ColumnName({disableSort: true}),
        ColumnHolePar()
    ]

    data?.results?.extendedInfos.filter(ei => ei.ei_code === 'PLAYOFF')
        .sort(({ ei_pos: prevOrder }, { ei_pos: currOrder }) => prevOrder - currOrder)
        .map(ei =>{
            cols.push(ColumnHole(data, ei))
        })

    cols.push(ColumnExpander({type: 'alwaysTrue', allExpanded: false}))

    return cols
}

